$(document).ready(function(){
  $(".product-video-thumb-icon").click(function () {
    $(this).closest('.product-video').find("video")[0].play();
    $(this).closest('.product-video').find(".product-video-thumb").hide();
});
$(".product-video video").on('click', function () {
    $(this).closest('.product-video').find("video")[0].pause();
    $(this).closest('.product-video').find(".product-video-thumb").show();
});

$('.daily-usees-item .popup-open').on('click', function (e) {
    e.stopPropagation(); // Prevent bubbling if needed
    var index = $(this).closest('.daily-usees-item').data('popup-index');
    $('.popup-container[data-popup-index="' + index + '"]').addClass('show');
});


        $('.close-popup').on('click', function () {
            $(this).closest('.popup-container').removeClass('show');
            $('.compare-popup').css('display' , 'none');
        });

        $('.custom_variants_bundle-header span').on('click', function () {
            $('.compare-popup').css('display' , 'flex');
        });

        $(document).on('click', function (e) {
            if ($(e.target).closest('.popup-container-content, .daily-usees-item').length === 0) {
                $('.popup-container').removeClass('show');
            }
    });

//     document.querySelectorAll('input[type="radio"]').forEach(radio => {
//         radio.addEventListener('click', function(event) {
//         event.preventDefault(); 
//     });
// });
$(".js-single-variant").on("click", function (e) {
  $('.custom_variants_bundle-pro').removeClass('active').hide();
  $(this).prev().prop("checked",true).trigger('change');
})
$(".js-bundle-variant").on("click", function (e) {
  $('.custom_variants_bundle-pro').addClass('active').show();
})
/* const bundle_type = document.querySelectorAll('input[name="bundle_type"]');
const bundle_options = document.querySelectorAll('input[name="bundle_option"]');
if(bundle_type) {
  bundle_type.forEach(function (radio) {
    radio.addEventListener('change', function (event) {
      event.preventDefault(); // Prevent default behavior
      if(radio.value == "bundle") {
        document.querySelector('.custom_variants_bundle-pro').classList.add('active');
        document.querySelector('.custom_variants_bundle-pro').style.display = 'block';
      } else if (radio.value == "single") {
        let optInd = radio.dataset.option;
        let valInd = radio.dataset.value;
        document.querySelector('.custom_variants_bundle-pro').classList.remove('active');
        document.querySelector('.custom_variants_bundle-pro').style.display = 'none';
        const checkedBundle = document.querySelector(".js-bundle-product-input:checked");
        checkedBundle.checked = false;
        checkedBundle.removeAttribute('checked');
        const variantOption = document.querySelector(`input[data-option="${optInd}"][data-value="${valInd}"]`)
        variantOption.checked = true;
        variantOption.dispatchEvent(new Event('change'));
      }
    });
  });
} */
/* if(bundle_options) {
  console.log('found bundle options');
  bundle_options.forEach(function (radio) {
    radio.addEventListener('change', function (event) {
      event.preventDefault(); // Prevent default behavior
      let optInd = radio.dataset.option;
      let valInd = radio.dataset.value;
      const variantOption = document.querySelector(`input[data-option="${optInd}"][data-value="${valInd}"]`);
      if(variantOption) {
        variantOption.checked = true;
        variantOption.dispatchEvent(new Event('change'));
        variantOption.nextElementSibling.click(); // Trigger click on the label
      }
    });
  }); 
} */
     /* $('input[name="bundle_type"]').on('change', function () {
      if($(this).val() == "bundle") {
        $('.custom_variants_bundle-pro').show();
        $('.custom_variants_bundle-pro').addClass('active');
      } else if($(this).val() == "single") {
        let optInd = $(this).data('option');
        let valInd = $(this).data('value');
        $('.custom_variants_bundle-pro').hide();
        $('.custom_variants_bundle-pro').removeClass('active');
        $('.js-bundle-product-input:checked').prop('checked', false);
        $(`input[data-option="${optInd}"][data-value="${valInd}"]`).prop('checked', true).trigger('change');
      }
    }); */
     /* $('input[name="bundle_option"]').on('change', function () {
        let optInd = $(this).data('option');
        let valInd = $(this).data('value');
        $(`input[data-option="${optInd}"][data-value="${valInd}"]`).prop('checked', true).trigger('change');
    }); */
    /* $(`.js-bundle-product-input`).on('change', function (e) {
      let optInd = $(this).data('option');
      let valInd = $(this).data('value');
      var selected_opt = $(`input[data-option="${optInd}"][data-value="${valInd}"]`);
      selected_opt.prop('checked', true).trigger('change'); 
    }) */
    
// Sticky cta old code start 

  //   window.addEventListener('scroll', function() { 
  //   const stickyCTA = document.getElementById('sticky-cta');
  //   const scrollThreshold = 1200; // Adjust as needed

  //   if (window.scrollY > scrollThreshold) {
  //     stickyCTA.classList.add('active'); // Add class when scrolled down
  //   } else {
  //     stickyCTA.classList.remove('active'); // Remove class when at the top
  //   }
  // });

  // Sticky cta old code end 


  // Sticky cta new code start 

  const stickyCTA = document.getElementById('sticky-cta');
const scrollThreshold = 1200; // Adjust as needed

if (stickyCTA) {
  window.addEventListener('scroll', function () {
    if (window.scrollY > scrollThreshold) {
      stickyCTA.classList.add('active');
    } else {
      stickyCTA.classList.remove('active');
    }
  });
}

// Sticky cta new code end 


  $(".custom_variants_bundle-pro-item label").click(function(){
    $(this).prev().prop("checked",true).trigger('change');
    var variant_title = $(this).find('h3 span.swatch-input__label-inner').text().trim();
    $(".sticky-cta__info strong").text(variant_title);
  });

  $(".jsX-bundle-color-slc").on("click", function (e) {
    var selected_color = $(this).text().trim();
    $(`.js-color-bundle[value="${selected_color}"]`).prop("checked", true).trigger('change');
    selected_color = selected_color.toLowerCase().replace(/\s+/g, '-');
    $(".custom_variants_bundle_img img").removeClass('active');
    $(`.custom_variants_bundle_img .${selected_color}`).addClass('active');
  })


  $('.health-experts-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4.5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  $('.happy-plungers-imgs').slick({
  dots: false,
  infinite: false,
  speed: 300, 
  slidesToShow: 3.3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$(".tub-colors--wrap input").on('change', function () {
  var color = $(this).val();
  console.log(color);
  color = color.toLowerCase();
  console.log(color);
  $(this).closest('.custom_variants_bundle-pro-item').find(`.bundle-variant-img.${color}`).addClass('active').siblings('.bundle-variant-img').removeClass('active');
})
});


$(document).ready(function() {
  $('.compare-with-other-content-header').on('click', function() {
    $(this).closest('.compare-with-other-content-item').toggleClass('active');
  });
  $("body").on('click', ".sticky-cta__button button", function () {
    $('.product-form .product-form__submit').click();
  })
});
